export default __webpack_public_path__ + "static/media/image_defaultbb.6a6f5d49.png";